import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/css';
import "swiper/css/pagination";
// import 'swiper/css/navigation';
import { Container } from '../common/AltCard';
// import { Autoplay, Pagination } from 'swiper/modules';
import { Autoplay, Navigation, Pagination } from "swiper";


interface perksProps {
    icon:string;
    title:string;
    desc:string;
}
export interface HowToProps {
    content : {
        titleN:string;
        titleI:string;
        subText:string;
        steps: perksProps[]
    }
}


const NewHowTo = ({content}:HowToProps) => {
  return (
    <div
        className="p-6 lg:p-10 bg-white"
        >
        <div className="flex justify-center flex-col items-center">
            <h1 className='lg:text-center text-[#35393F] font-Rob font-[600] text-[24px] lg:text-[28px] leading-[28px] md:text-[44px] md:leading-[45px]'>{content.titleN} <span className='text-primary text-[32px] md:text-[50px] lg:text-[55px] font-[800] font-playfair italic'>{content.titleI}</span></h1>
            <p className='lg:-center font-int font-[300] text-[16px] text-[#7A828F] my-4 lg:w-[50%] md:mb-8'>{content.subText}</p>
        </div>
        <div className="mt-10 relative ">
          {/* <div className=""> */}
            <Swiper
              spaceBetween={30}
              // pagination={{
              //   clickable: true,
              // }}
              breakpoints={{
                320: { slidesPerView: 1 },
                640: { slidesPerView: 2 },
                1024: { slidesPerView: 3 },
                1280: { slidesPerView: 4 },
              }}
              // navigation={true}
              modules={[]}
              className="mySwiper"
            >
              {content.steps.map((i, id) => (
                <SwiperSlide key={id}>
                  <div className="px-4 pt-4 pb-6 relative h-full">
                    <div
                      className="rounded-lg w-full h-[70%] absolute bottom-0 left-0"
                      style={{ backgroundColor: "rgba(0, 120, 1, 0.04)" }}
                    ></div>
                    <div className="flex justify-between items-end">
                      <img src="/img/user_icon.png" alt="" />
                      <img className="h-[170px] lg:h-[150px]" src={i.icon} alt="" />
                    </div>
                    <div className="mt-6 h-full space-y-4">
                      <p className="text-[#555C63] font-bold">{i.title}</p>
                      <p className="text-[#555C63] text-[14px]">{i.desc}</p>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>            
          {/* </div> */}

        </div>

    </div>
  )
}

export default NewHowTo